<template>
  <div>
    <el-dialog title="退货管理" :visible.sync="visible" width="60%" center>
      <form class="form-horizontal">
        <div class="form-group" v-if="'MONEY'==orderReturn.returnType">
          <label class="col-sm-2 control-label">货物状态：</label>
          <div class="col-sm-10">
            <input type="text" v-model="orderReturn.goodsStatus" class="form-control" placeholder="请输入货运号"/>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">退款原因：</label>
          <div class="col-sm-10">
            <input type="text" v-model="orderReturn.cause" class="form-control" placeholder="退款原因"/>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">图片凭证：</label>
          <div class="img-pin">
            <img v-for="(item, index) in attaches" :key="index" :src="dynamicPath + item.path"
                 @click="clickImg(item.path)"/>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-2 control-label">退款说明：</label>
          <div class="col-sm-10">
            <textarea v-model="orderReturn.remark" class="form-control" placeholder="请输入说明"></textarea>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">处理结果：</label>
          <div class="col-sm-10">
            <select v-model="orderReturnModel.status" class="form-control">
              <option value="SUCCESS">同意</option>
              <option value="REJECT">拒绝</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">处理说明：</label>
          <div class="col-sm-10">
            <textarea v-model="orderReturnModel.checkRemark" class="form-control" placeholder="请输入说明"></textarea>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-10 col-sm-offset-2">
            <button type="button" @click="saveOrderReturn" class="btn btn-info btn-sm">处理</button>
            <button type="button" @click="visible=false" class="btn btn-sm">取消</button>
          </div>
        </div>
      </form>
    </el-dialog>

    <el-dialog title="查看图片" :visible.sync="openImgDialog" width="60%" center>
      <div class="open_img">
        <img :src="dynamicPath + path"/>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderId: '',
      orderReturn: {},
      attaches: [],
      orderReturnModel: {},
      dynamicPath: config.dynamicResourcePath,
      visible: false,
      path: '',
      openImgDialog: false,
      checkStatuses: [{label: '通过', value: 'SUCCESS'}, {label: '拒绝', value: 'REJECT'}],
    }
  },
  props: {
    success: {
      type: Function
    }
  },
  methods: {
    clickImg(_path) {
      this.path = _path;
      this.openImgDialog = true;
    },
    saveOrderReturn() {
      var _this = this;
      if (!_this.orderReturnModel.status) {
        _this.$message({
          showClose: true,
          message: '请选择结果',
          duration: 1000,
          type: 'error',
        });
        return false;
      }
      _this.$confirm('确认该操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.orderReturnModel.orderId = _this.orderId;
        _this.$common.my_ajax({
          url: '/orderReturn/saveCheck',
          data: _this.orderReturnModel,
          success: function (response) {
            _this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.visible = false;
                if (_this.success) {
                  _this.success();
                }
              }
            });
          }
        });
      }).catch((e) => {
        console.log(e);
      });
    },

    openDialog(_orderId) {
      this.orderId = _orderId;
      this.findOrderReturn(() => {
        this.visible = true;
        this.findAttach()
      })
    },
    findOrderReturn(_callback) {
      var _this = this;
      _this.$common.my_ajax({
        url: '/orderReturn/findByOrderId',
        data: {
          orderId: _this.orderId
        },
        success(response) {
          _this.orderReturn = response.item;
          if (_callback) {
            _callback();
          }
        }
      });
    },
    findAttach() {
      var _this = this;
      _this.$common.my_ajax({
        url: '/attach/findByBusinessId',
        data: {
          businessId: _this.orderReturn.id
        },
        success(response) {
          _this.attaches = response.items || [];
        }
      });
    }
  }
}
</script>
<style scoped>
.img-pin img {
  margin-left: 17px;
  float: left;
  width: 100px;
  height: 100px;
}

.open_img img {
  width: 100%;
  height: 100%;
}
</style>